import { useState } from "react";

import { useI18n } from "utils/with-i18n.utils";

interface CardProps {
  value: string;
  base: string;
  hover: string;
}

export const Card = ({ value, base, hover }: CardProps) => {
  const i18n = useI18n();
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <div
      className="flex overflow-hidden relative flex-col gap-3 p-3 mx-3 rounded-xl border-[1px] border-black lg:p-0 lg:mx-0 lg:max-w-[400px] "
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <section className="flex -z-10 flex-col justify-around items-center w-full h-full text-center bg-white rounded-xl lg:gap-6 lg:py-9 lg:px-7">
        <span
          data-shadow={i18n.t(value)}
          className="relative before:absolute before:top-[4px] before:left-[4px] before:-z-10 text-[42px] font-black text-yellow before:text-black before:whitespace-nowrap before:content-[attr(data-shadow)] lg:text-7xl"
          style={{
            textShadow:
              "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
          }}
        >
          {i18n.t(value)}
        </span>
        <p className="text-base font-normal lg:text-2xl lg:leading-[24px]">
          {i18n.t(base, {}, { html: true })}
        </p>
      </section>
      <section
        className={`flex items-center justify-center h-full w-full lg:absolute bottom-0 ${
          isHover ? "" : "lg:translate-y-full"
        }  bg-pastel-green px-7 text-center rounded-xl `}
        style={{ transition: "1s cubic-bezier(.175, .885, .32, 1.275)" }}
      >
        <p className="text-base font-normal lg:text-[22px] lg:leading-[30px]">
          {i18n.t(hover, {}, { html: true })}
        </p>
      </section>
    </div>
  );
};
